import { type SecurityProps, mkSecurity } from './securitiesTypes';

export const transformResponseToResources = (response?: { data?: { resources?: SecurityProps[] } } | null) =>
  response?.data?.resources?.map(mkSecurity);
